import { FileText, Pencil } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Attachment,
  AttachmentActions,
  AttachmentContent,
  AttachmentDescription,
  AttachmentMedia,
  AttachmentTitle,
} from '@/components/ui/attachment'

export function V2RohsSharedEvidenceFileItem({
  fileName,
  canWrite,
  onEdit,
}: {
  fileName: string
  canWrite: boolean
  onEdit: () => void
}) {
  const { t } = useTranslation('common')

  return (
    <Attachment state='done' size='sm' className='w-full'>
      <AttachmentMedia>
        <FileText aria-hidden />
      </AttachmentMedia>
      <AttachmentContent>
        <AttachmentTitle title={fileName}>{fileName}</AttachmentTitle>
        <AttachmentDescription>
          {t('v2.pages.products.detail.drawings.uploaded')}
        </AttachmentDescription>
      </AttachmentContent>
      {canWrite ? (
        <AttachmentActions>
          <Button
            type='button'
            variant='ghost'
            size='icon-sm'
            aria-label={t(
              'v2.pages.products.detail.sharedEvidence.actions.edit'
            )}
            onClick={onEdit}
          >
            <Pencil className='size-4' />
          </Button>
        </AttachmentActions>
      ) : null}
    </Attachment>
  )
}
